import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services/api.service';
import { Observable } from 'rxjs';
import { SearchRequest } from '../interfaces/search-request';

@Injectable({
  providedIn: 'root',
})
export class SerachRequestsService {
  constructor(private apiService: ApiService) {}

  getLatest(): Observable<SearchRequest[]> {
    return this.apiService.get<SearchRequest[]>('search/latest');
  }

  getTrending(): Observable<string[]> {
    return this.apiService.get<string[]>('tag/popular');
  }

  getPopular(): Observable<string[]> {
    return this.apiService.get<string[]>('tag/popular/extended');
  }
}
